import { useFormikContext } from 'formik';

import PaypalButton from 'components/common/PaypalButton';
import Subheading from 'components/common/Subheading';
import Text from 'components/common/Text';
import { BRAINTREE } from 'lib/constants/payments';
import { getPaypalToken } from 'services/RequestService/endpoints/user';

const PayPalCheckout = ({
  setPayPalDetails,
  containerClass = '',
  buttonClass = '',
  onPaypalClick,
}) => {
  const { resetForm, values } = useFormikContext();

  return (
    <div className="mx-auto">
      <Subheading brandStylesOverrides="h7" className="mb-4 text-center uppercase">
        Sign Up With PayPal
      </Subheading>
      <PaypalButton
        onUpdatePayment={payPalDetails => {
          setPayPalDetails(payPalDetails);
          resetForm({ values: { ...values, vendor: BRAINTREE } });
          return { ok: true };
        }}
        onGetPaypalToken={getPaypalToken}
        styles={{
          layout: 'horizontal',
          shape: 'rect',
          label: 'paypal',
        }}
        containerClass={containerClass}
        buttonClass={buttonClass}
        onPaypalClick={onPaypalClick}
      />
      <div className="text--hr-header text--hr-header--left text--hr-header--right my-4">
        <Text
          htmlElement="span"
          brandStylesOverrides="h7"
          className="text--hr-header__heading font-medium uppercase"
        >
          {' '}
          OR{' '}
        </Text>
      </div>
    </div>
  );
};

PayPalCheckout.propTypes = {
  setPayPalDetails: PropTypes.func.isRequired,
  containerClass: PropTypes.string,
  buttonClass: PropTypes.string,
  onPaypalClick: PropTypes.func.isRequired,
};

export default PayPalCheckout;
